module.exports = __webpack_public_path__ + "img/scopic-logo.7c293a3f.svg";